<!-- Icon Button trigger -->
<button
  mat-icon-button
  [matMenuTriggerFor]="groupingMenu"
  [matTooltip]="tooltipText"
  [color]="isGrouped ? 'primary' : undefined"
  class="grouping-icon-button"
  [class.grouped-active]="isGrouped"
>
  <mat-icon>{{ activeIcon }}</mat-icon>
</button>

<!-- Grouping menu -->
<mat-menu #groupingMenu="matMenu" class="bp-grouping-menu">
  <!-- Header -->
  @if (showMenuHeader) {
    <div class="menu-header">{{ 'routing.SUB_ROUTE_PARTNERS.GROUPING.MENU_HEADER' | t }}</div>
  }

  <!-- Option: Sin agrupar -->
  <button
    mat-menu-item
    class="compact-option"
    [class.active]="value === BPGroupingCriteria.NONE"
    (click)="selectGrouping(BPGroupingCriteria.NONE)"
  >
    <mat-icon class="menu-icon">view_list</mat-icon>
    <span>{{ 'routing.SUB_ROUTE_PARTNERS.GROUPING.LABELS.NONE' | t }}</span>
    @if (value === BPGroupingCriteria.NONE) {
      <mat-icon class="check-icon">check</mat-icon>
    }
  </button>

  <!-- Sections -->
  @for (section of BP_GROUPING_SECTIONS; track section.name) {
    <mat-divider></mat-divider>

    <!-- Section header -->
    <div class="section-header">
      <mat-icon class="section-icon">{{ section.icon }}</mat-icon>
      <span>{{ getSectionName(section) }}</span>
    </div>

    <!-- Section options -->
    @for (option of section.options; track option) {
      <button mat-menu-item class="compact-option" [class.active]="value === option" (click)="selectGrouping(option)">
        <mat-icon class="menu-icon">{{ BP_GROUPING_ICONS[option] }}</mat-icon>
        <span>{{ getGroupingLabel(option) }}</span>
        @if (value === option) {
          <mat-icon class="check-icon">check</mat-icon>
        }
      </button>
    }
  }
</mat-menu>
